import { CandidateListPage } from '@pages/candidate';
import { createMeta } from '@shared/utils';

export function meta() {
  return createMeta('Кандидаты', 'Управление кандидатами');
}

export default CandidateListPage;
